<div class="redemption-container">
  <h3>Redeem your sponsorship</h3>
  <div class="alert alert-danger" *ngIf="error">{{error}}</div>
  <label>Enter the 7-character Sponsorship Code below:</label>
  <input type="text" class="form-control" [(ngModel)]="code" />

  <div class="actions">
    <tyt-form-submit-button (click)="redeem()">Continue</tyt-form-submit-button>
  </div>
</div>